<template>
  <v-container>
    <material-card
      :title="Item.title"
      :text="Item.subTitle"
      color="green"> 
      <v-form
      ref="form"
      v-model="valid"
      lazy-validation>
        <v-container py-0>
          <v-layout wrap>
            <v-flex md6>
               <v-text-field
                type="text"
                :label="'Name'"
                :name="'Name'"
                class="green-input"
                 v-model="Value.name"
                 />
                 
            </v-flex>
         
            <v-flex md6>
               <v-text-field
                type="text"
                :label="'Name (Bangla)'"
                :name="'Name'"
                class="green-input"
                 v-model="Value.name_bn"
                 />
                 
            </v-flex>

            <v-flex md6>
               <v-text-field
                type="number"
                :label="'Price'"
                :name="'price'"
                class="green-input"
                 v-model="Value.price"
                 />
                 
            </v-flex>

            <v-flex
              xs12
              text-xs-right>
              <v-btn
                class="mx-0 font-weight-light"
                color="success" @click="onClickButton">{{ Item.submitText }}</v-btn>
              <v-btn
                class="mx-2 font-weight-light"
                color="info" @click="closeModal">Close</v-btn>
                
            </v-flex> 
          </v-layout>
        </v-container>
      </v-form>
    </material-card>
  </v-container>
</template>

<script>
export default {
  props: {
    // title: String,
    Item: Object,
    Field: Array,
    CourseTypeList: Array,
    Value: Object
  },
  watch: {
    dialog() {
        this.$refs.form.reset()
    }
  },
  data () {
      return {
      overlay: false,
      valid: true,
      modelList: {'course_type_id': null},
      courseTypeRules: [
          v => !!v || 'Please select Course type',
      ],
      nameRules: [
        v => !!v || 'Course name is required',
        v => (v && v.length <= 190) || 'Course name must be less than 190 characters',
        v => /^[\w. ]+$/.test(v) || 'Special character not allowed'
      ],
      nameBnRules: [
        v => !!v || 'Course name Bangla is required',
        v => (v && v.length <= 190) || 'Course name bangla must be less than 190 characters'
      ],
      statusRules: [
        v => !!v || 'Status is required',
        v => (v && v.length <= 30) || 'Status must be less than 30 characters'
      ],
      priceRules: [
        v => !!v || 'Price is required',
      ],
      statusList: [
        { item: 'active'},
        { item: 'inactive'},
      ]
      }
  },

  created () {
    console.log(this.Value)
    this.modelList = this.Value
  },
  methods: {
    onClickButton (event) {
      if (this.$refs.form.validate()) {
        this.overlay = true
        this.$emit('emitted', this.Value)
      } else {
        console.log('Second')
      }
    },
    closeModal () {
      this.$emit('closed')
    }
  }
}
</script>
